export const isPlainObject = (value: unknown): value is Record<string, unknown> => {
    return typeof value === 'object' && value !== null && !Array.isArray(value)
}

export const getTargetOrigin = ({ referrer = document.referrer }: { referrer?: string } = {}): string => {
    if (!referrer) return '*'

    try {
        return new URL(referrer).origin
    } catch {
        return '*'
    }
}
